module.exports = __webpack_public_path__ + "static/media/190x190px_minasidor.d9204630.png";